import GlassCard from "./GlassCard";

export default function StatCard({ label, value, hint, badge, className = "" }) {
  return (
    <GlassCard className={`p-5 hover:shadow-md transition ${className}`}>
      <div className="text-sm text-slate-500 dark:text-slate-400 flex items-center gap-2 mb-2">
        {badge}
        <span>{label}</span>
      </div>
      <div className="text-3xl font-bold text-slate-900 dark:text-slate-100">{value}</div>
      {hint && <div className="text-sm text-slate-600 dark:text-slate-400 mt-1">{hint}</div>}
    </GlassCard>
  );
}
